const selection = {
  Campaign: [
    {
      name: 'Yves Saint Laurent',
      image: `campaign/yves-saint-laurent.jpg`,
      videoId: '461389840',
      artist: 'Mooders',
      track: 'Bloody Fools',
      campaign: 'Yves Saint Laurent - Encre de Peau',
      slug: 'mooders-bloody-fools',
    },
    {
      name: 'Prada',
      image: `campaign/prada.jpg`,
      videoId: '461379177',
      artist: 'Combray',
      track: 'Eunice',
      campaign: 'Prada Fall Winter 2019',
      slug: 'combray-eunice',
    },
    {
      name: 'Shu Uemura',
      image: `campaign/shu-uemura.jpg`,
      videoId: '461378044',
      artist: 'The Supermen Lovers',
      track: 'Vodka feat. Igor and Natty Fensie',
      campaign: 'Mattitude',
      slug: 'the-supermen-lovers-vodka-feat-igor-and-natty-fensie',
    },
    {
      name: 'Vogue',
      image: `campaign/vogue.jpg`,
      videoId: '461378017',
      artist: 'Pete Bassman',
      track: 'Music For Modern Living',
      campaign: 'Vogue - Waking uo with Karlie Kloss',
      slug: 'pete-bassman-music-for-modern-living',
    },
  ],
  Advertising: [
    {
      name: 'Dior',
      image: `advertising/dior.jpg`,
      videoId: '384753899',
      artist: 'Hot Spell',
      track: 'Chocolat (Instrumental)',
      campaign: 'Dior Forever Foundation',
      slug: 'hot-spell-chocolat-instrumental',
    },
    {
      name: 'Instagram',
      image: `advertising/instagram.jpg`,
      videoId: '384755856',
      artist: 'Discodromo',
      track: 'Star and Rain',
      campaign: 'Instagram TV',
      slug: 'discodromo-star-and-rain',
    },
    {
      name: 'Orange',
      image: `advertising/orange.jpg`,
      videoId: '384754095',
      artist: 'Lost Idols',
      track: 'Apples & Pears',
      campaign: 'Orange',
      slug: 'lost-idols-apples-and-pears',
    },
    {
      name: 'Mc Donalds',
      image: `advertising/mcdonalds.jpg`,
      videoId: '384749896',
      artist: 'Throes and The Shine',
      track: 'Guerreros feat. La Yegros',
      campaign: 'Mc Donald - Double Big Mac',
      slug: 'throes-and-the-shine-guerreros-feat-la-yegros',
    },
  ],
  Branding: [
    {
      name: 'Hermes',
      image: `branding/hermes.jpg`,
      videoId: '384750632',
      artist: 'Golden Bug',
      track: 'Taste Of Love feat. Pajaro Sunrise',
      campaign: "Hermès Men's Universe",
      slug: 'golden-bug-taste-of-love-feat-pajaro-sunrise',
    },
    {
      name: 'Gucci',
      image: `branding/gucci.jpg`,
      videoId: '384750291',
      artist: 'G23',
      track: 'Mains',
      campaign: 'GUCCI & GQ - The Performers - Act VII',
      slug: 'g23-mains',
    },
    {
      name: 'Mailchimp',
      image: `branding/mailchimp.jpg`,
      videoId: '384750534',
      artist: 'Joy Boy',
      track: 'Bimbi',
      campaign: `MailChimp's "JailBlimp"`,
      slug: 'joy-boy-bimbi',
    },
    {
      name: 'Louis Vuitton',
      image: `branding/louisvuiton.jpg`,
      videoId: '383571376',
      artist: 'Golden Bug',
      track: 'One Way (In Fields Remix Edit)',
      campaign: 'Louis Vuitton High Jewelry Collection',
      slug: 'golden-bug-one-way-in-fields-remix-edit',
    },
  ],
  Cinema: [
    {
      name: 'Sky',
      image: `cinema/sky_large.jpg`,
      slug: 'ele-love-me-my-love-above-all',
      track: 'Love Me My Love,Above All',
      artist: 'Ele',
    },
    {
      name: 'Ghostland',
      image: `cinema/ghostland_large.jpg`,
      slug: 'killason-ready-or-not',
      track: 'Ready Or Not',
      artist: 'Killason',
    },
    {
      name: 'The Other Side',
      image: `cinema/the-other-side.jpg`,
      slug: 'herr-styler-we-are-the-ones-r-ash-remix',
      track: 'We Are The Ones (R-ASH Remix)',
      artist: 'Herr Styler',
    },
    {
      name: "Jusqu'A La Garde",
      image: `cinema/jusqu-a-la-garde_large.jpg`,
      slug: 'throes-and-the-shine-guerreros-feat-la-yegros',
      track: 'Guerreros (feat. La Yegros)',
      artist: 'HerrThroes and The Shine',
    },
  ],
  Series: [
    {
      name: 'La Casa de las Flores',
      image: `series/la-casa-de-las-flores_large.jpg`,
      slug: 'begun-dora',
      track: 'Dora',
      artist: 'Begun',
    },
    {
      name: 'Luis Miguel',
      image: `series/luis-miguel_large.jpg`,
      slug: 'vision-paname-music-television',
      track: 'Music Television',
      artist: 'Vision Paname',
    },
    {
      name: 'The Rain',
      image: `series/THE_RAIN_poster-1200.jpg`,
      slug: 'yael-meyer-yo-soy',
      track: 'Yo Soy',
      artist: 'Yael Meyer',
    },
    {
      name: 'Jack Ryan',
      image: `series/tom-clancy-s-jack-ryan_large.jpg`,
      slug: 'billy-bats-hoody-melo',
      track: 'Hoody Melo',
      artist: 'Billy Bats',
    },
  ],
}

export default selection
